import { Link } from 'react-router-dom';
import { PageWrapper } from '../components/layout/PageWrapper';
import { Seo } from '../components/Seo';

export function TermsPage() {
  return (
    <PageWrapper className="max-w-3xl">
      <Seo title="Условия использования" path="/terms" noindex />
      <h1 className="text-4xl font-bold text-white mb-2">Условия использования</h1>
      <p className="text-gray-500 text-sm mb-10">Последнее обновление: 27 мая 2026 г.</p>

      <div className="space-y-8 text-gray-300 leading-relaxed">
        <section>
          <h2 className="text-xl font-semibold text-white mb-3">1. Принятие условий</h2>
          <p>
            Используя сайт <span className="text-mafia-accent">mafiaclub.com.au</span> и
            бронируя место на игры Клуба Мафии Квинсленда, вы принимаете настоящие условия.
            Если вы не согласны с ними — пожалуйста, не используйте сайт.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">2. Участие в играх</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>Участие в играх открыто для лиц от 16 лет.</li>
            <li>Игры проводятся по субботам с 18:00 в библиотеке Banyo (284 St Vincents Rd, Banyo QLD 4014).</li>
            <li>Организаторы вправе отказать в участии за нарушение правил клуба или неуважительное поведение.</li>
            <li>Правила игры Мафия доступны на странице{' '}
              <Link to="/rules" className="text-mafia-accent hover:underline">Правила</Link>.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">3. Бронирование и оплата</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>
              Бронирование места подтверждается только после успешной оплаты. Неоплаченные
              бронирования автоматически отменяются.
            </li>
            <li>
              Стоимость участия указана на странице бронирования и взимается в австралийских
              долларах (AUD).
            </li>
            <li>
              Оплата обрабатывается сервисом Stripe. Данные вашей карты передаются напрямую
              в Stripe и не хранятся на наших серверах.
            </li>
            <li>
              На каждую игру доступно ограниченное количество мест. Бронирование не гарантируется
              до завершения оплаты.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">4. Возврат средств</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>
              Полный возврат возможен при отмене бронирования не позднее чем за <strong className="text-white">48 часов</strong> до начала игры.
            </li>
            <li>
              При отмене менее чем за 48 часов возврат не производится, за исключением случаев
              отмены самой игры организаторами.
            </li>
            <li>
              Если игра отменяется организаторами, все участники получают полный возврат
              в течение 5–10 рабочих дней.
            </li>
            <li>
              Для отмены бронирования воспользуйтесь личным кабинетом на странице{' '}
              <Link to="/reserve" className="text-mafia-accent hover:underline">Бронирование</Link>.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">5. Аккаунт и авторизация</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>
              Для бронирования необходим аккаунт Google или Apple. Вы несёте ответственность
              за безопасность своего аккаунта.
            </li>
            <li>
              Мы оставляем за собой право заблокировать аккаунт при нарушении правил клуба.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">6. Ограничение ответственности</h2>
          <p>
            Клуб не несёт ответственности за личные вещи участников, травмы, полученные
            по собственной неосторожности, а также за действия третьих лиц. Сайт
            предоставляется «как есть» без каких-либо гарантий бесперебойной работы.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">7. Конфиденциальность</h2>
          <p>
            Обработка персональных данных описана в нашей{' '}
            <Link to="/privacy" className="text-mafia-accent hover:underline">
              Политике конфиденциальности
            </Link>.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">8. Применимое право</h2>
          <p>
            Настоящие условия регулируются законодательством штата Квинсленд, Австралия.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">9. Контакты</h2>
          <p>
            По вопросам, связанным с условиями использования:{' '}
            <a href="mailto:info@mafiaclub.com.au" className="text-mafia-accent hover:underline">
              info@mafiaclub.com.au
            </a>
          </p>
        </section>
      </div>
    </PageWrapper>
  );
}
